import baseConfig from '@config/baseConfig';

const phaserConfig = baseConfig();

const audio = {
  bgaudio: null,
  correctAnswer: null,
  wrongAnswer: null,
  waterCan: null,
  watering: null,
  flowerBlossoming: null,
  hover: null,
  hintAlert: null,
  yay: null,
  sunShining: null,
  ta1: null,
  ta2: null,
  ta3: null,
  ta4: null,
};

export const config = {
  width: phaserConfig.width,
  height: phaserConfig.height,
  audio,
};

export const gameState = {
  score: 0,
  attempted: 0,
  questionNumber: 0,
  hints: 0,
  gameWin: true,
  firstMistake: false,
  hneed: false,
  attempts: 0,
  level: 0,
  clicked: false,
  cam: null,
  retry: false,
  correct: 0,
};
